interface InnoveraLoadingProps {
  size?: number;
}

export function InnoveraLoading({ size = 20 }: InnoveraLoadingProps) {
  return (
    <>
      <style>{`
        @keyframes innovera-draw {
          to {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
        style={{ transform: "scaleX(-1)" }}
      >
        <defs>
          <mask
            id="innovera-loading-mask"
            style={{ maskType: "alpha" } as React.CSSProperties}
            maskUnits="userSpaceOnUse"
            x="2"
            y="2"
            width="21"
            height="19"
          >
            <path
              d="M22.2522 20.914H20.4254L12.327 4.87159L4.98838 19.4076L12.6133 19.386L13.2835 20.9148H2.40002L11.7395 2.40039H12.9119L12.978 2.53239L22.2522 20.914Z"
              fill="#18181B"
            />
          </mask>
        </defs>
        <g mask="url(#innovera-loading-mask)">
          <path
            d="M22 22L12.25 3.75L4 20H14"
            stroke="#FF603E"
            strokeWidth="3"
            fill="none"
            style={{
              strokeDasharray: 60,
              strokeDashoffset: 60,
              animation: "innovera-draw 1.5s linear infinite"
            }}
          />
        </g>
      </svg>
    </>
  );
}
